module.exports = __webpack_public_path__ + "static/media/percentage-error.f9d4debc.svg";